
import { Loader2 } from "lucide-react";
import ExpiryTrendChart from "../charts/ExpiryTrendChart";
import CategoryDistributionChart from "../charts/CategoryDistributionChart";
import InventoryHealthChart from "../charts/InventoryHealthChart";
import { CategoryDistribution, ExpiryTrend, InventoryHealth } from "@/utils/dashboardUtils";

interface AnalyticsTabProps {
  categoryDistribution: CategoryDistribution[];
  expiryTrend: ExpiryTrend[];
  inventoryHealth: InventoryHealth[];
  isLoading: boolean;
}

export default function AnalyticsTab({ 
  categoryDistribution,
  expiryTrend,
  inventoryHealth,
  isLoading 
}: AnalyticsTabProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-expitrack-primary" />
        <span className="ml-3 text-gray-600">Loading analytics data...</span>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <ExpiryTrendChart expiryTrend={expiryTrend} />
        <CategoryDistributionChart categoryDistribution={categoryDistribution} />
        <InventoryHealthChart inventoryHealth={inventoryHealth} />
      </div>
    </div>
  );
}
